// The persistent "Adulticide Treatment Areas 2026" layer that lives on the adulticide
// webmap. Treatment areas are written here as Status='Draft' while they're being curated
// in the builder, then flipped to 'Upcoming' by "Schedule for treatment".
//
// Shared by BuilderPage (writes/schedules), SprayNotificationsCard and MarkTreatedPanel (both
// read the scheduled areas' subgrids) so they all target the same layer.

const KEY = "pioneer_treatment_layer_id";

export const DEFAULT_TREATMENT_LAYER_ID = "dd252cfcbd7b44cfbeecc6a9370c48d7";

export function getTreatmentLayerId(): string {
  return localStorage.getItem(KEY) || DEFAULT_TREATMENT_LAYER_ID;
}

export function setTreatmentLayerId(id: string): void {
  if (id) localStorage.setItem(KEY, id);
  else localStorage.removeItem(KEY);
}
